import React from "react";
import EventCard from "./EventCard";
import { dateFormate } from "./Utility";

export interface EventTileProps {
  displayEvents: any[];
  groupedEvents: Record<string, any[]>;
  handleJoinMeeting: (event: any) => void;
  handleEventCardClick?: (event: any) => void;
}

const EventTile: React.FC<EventTileProps> = ({
  displayEvents,
  groupedEvents,
  handleJoinMeeting,
  handleEventCardClick,
}) => {
  if (!displayEvents?.length) return null;

  return (
    <div className="flex flex-col gap-[14px]">
      {Object.entries(groupedEvents).map(([dateString, grouped]) => (
        <div key={dateString} className="flex flex-col gap-2">
          <span className="dividerStyle">
            {dateFormate(dateString, "DAY MM/DD/YYY")}
          </span>
          <div className="flex flex-wrap gap-[10px]">
            {grouped.map((event: any) => (
              <EventCard
                key={event.Id}
                event={event}
                onJoinMeeting={handleJoinMeeting}
                onEventCardClick={handleEventCardClick}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventTile;
